import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../utils/constants';
import { getAuthToken } from '../../utils/authToken';

const authHeaders = (getState) => {
  const token = getAuthToken(getState);
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getPosters = createAsyncThunk(
  'posters/getPosters',
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${BASE_URL}/posters`, {
        headers: authHeaders(thunkAPI.getState),
      });
      return res.data;
    } catch (err) {
      console.log('Помилка при отриманні постерів:', err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const createPoster = createAsyncThunk(
  'posters/createPoster',
  async (formData, thunkAPI) => {
    try {
      const res = await axios.post(`${BASE_URL}/posters`, formData, {
        headers: authHeaders(thunkAPI.getState),
      });
      return res.data;
    } catch (err) {
      console.log('Помилка при создании постера:', err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const updatePoster = createAsyncThunk(
  'posters/updatePoster',
  async ({ id, formData }, thunkAPI) => {
    try {
      const res = await axios.post(`${BASE_URL}/posters/${id}`, formData, {
        headers: authHeaders(thunkAPI.getState),
      });
      return res.data;
    } catch (err) {
      console.log('Помилка при оновленні постера:', err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const deletePoster = createAsyncThunk(
  'posters/deletePoster',
  async (id, thunkAPI) => {
    try {
      await axios.delete(`${BASE_URL}/posters/${id}`, {
        headers: authHeaders(thunkAPI.getState),
      });
      return id;
    } catch (err) {
      console.log('Помилка при видаленні постера:', err);
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const postersSlice = createSlice({
  name: 'posters',
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPosters.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPosters.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(getPosters.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createPoster.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createPoster.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createPoster.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updatePoster.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePoster.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.list.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(updatePoster.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deletePoster.fulfilled, (state, action) => {
        state.list = state.list.filter((item) => item.id !== action.payload);
      });
  },
});

export default postersSlice.reducer;
